import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import mergeClassNames from '../Legacy/Commons/helpers/mergeClassNames';
import SuspenseFallback from '../SuspenseFallback';

// Generic app layout with horizontal padding and max-width for the content, whithout menu
const LayoutWithoutMenu = ({ noPadding = false }) => {
  const className = mergeClassNames(
    'bg-neutro-100 mx-auto max-w-[1600px] sm:px-14 2xl:px-28',
    noPadding ? '' : 'pb-14',
  );

  return (
    <main id="app" className="h-screen bg-neutro-100">
      <section id="content" className={className}>
        <Suspense fallback={<SuspenseFallback />}>
          <Outlet />
        </Suspense>
      </section>
    </main>
  );
};

export default LayoutWithoutMenu;
